import { Link } from "react-router-dom";
import { Logo } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { LEGAL } from "@/data/legal";

export default function Policy({ kind }) {
  const doc = LEGAL[kind];
  return (
    <div data-testid={`${kind}-page`}>
      <div className="min-h-screen max-w-3xl mx-auto px-5 sm:px-8 py-16">
        <Link to="/" className="flex items-center gap-3" data-testid="policy-home-link"><Logo /><span className="text-sm text-slate-400">Back to home</span></Link>
        <p className="eyebrow mt-16">Elite Performance Lab</p>
        <h1 className="mt-4 font-display font-extrabold tracking-tight text-3xl sm:text-6xl">{doc.title}</h1>
        <p data-testid="policy-draft-notice" className="mt-6 rounded-2xl border border-orange-400/30 bg-orange-400/[0.06] px-5 py-3 text-sm text-orange-200">
          Draft — version draft-2026-10. This document is subject to legal review before publication.
        </p>
        <div className="mt-10 space-y-8">
          {doc.sections.map(([h, body]) => (
            <section key={h}>
              <h2 className="font-display font-bold text-xl tracking-tight">{h}</h2>
              <p className="mt-2 text-slate-300 leading-relaxed">{body}</p>
            </section>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
}
